export default __webpack_public_path__ + "static/media/dummy.1a721233.pdf";